import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Compbaser } from "../compbaser";
import { ExperienceLevelType, experienceOptions, IAppStatic, IUser } from "../../interfaces";
import { AccessService, AppService, LocalStoreService, StoreSelectorsService } from "../../services";
import { DEFAULT_RESELLER_ID } from "../../common";
import { Lib } from "libs/Lib";
import { map, Observable } from "rxjs";

const { version: version } = require("../../../../package.json");
import { Pipe, PipeTransform } from "@angular/core";
import { MatSelect } from "@angular/material/select";

@Pipe({
    name: "experienceIcon",
    pure: true, // ensures it's only re-evaluated when input changes
})
export class ExperienceIconPipe implements PipeTransform {
    transform(level: ExperienceLevelType): string {
        return level === ExperienceLevelType.ADVANCED ? "donut_small" : "donut_large";
    }
}

@Component({
    selector: "app-header",
    styleUrls: ["./header-component.scss"],
    templateUrl: "./header-component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent extends Compbaser implements AfterViewInit {

    @Input() showMenu;
    @ViewChild('expSelect') expSelect: MatSelect;

    skillOptions = experienceOptions;
    appStatic: IAppStatic;
    user: IUser;
    name = "";
    devMode = "";
    largeLogo = "1";
    experienceLevel: ExperienceLevelType = ExperienceLevelType.BEGINNER;
    showExperienceLevel = "0";
    businessName = "";
    resellerId = DEFAULT_RESELLER_ID;
    upgradable: boolean;
    dashboardMode: boolean;
    fasterqEnabled = "0";
    showHelpEnabled = "0";
    enterpriseMode: boolean;
    showAccount = true;
    enableDynawebs = false;

    navEnterprise$: Observable<string>;
    navUser$: Observable<string>;
    signStudioProducts$: Observable<string>;
    signStudioDownloads$: Observable<string>;
    signStudioExperienceLevel$: Observable<string>;
    signStudioHelp$: Observable<string>;
    signStudioFasterQ$: Observable<string>;
    signStudioSettings$: Observable<string>;


    constructor(private router: Router,
                private storeSelector: StoreSelectorsService,
                private localStoreService: LocalStoreService,
                private appService: AppService,
                private route: ActivatedRoute,
                private accessService: AccessService,
                private cd: ChangeDetectorRef,
    ) {
        super();
        console.log(`> SignStudio ver ${version}`);
        this.cod(
            this.storeSelector.getUser().subscribe((user) => {
                this.user = user;
                this.updateBusinessName();
                this.upgradable = Lib.IsAccountUpgradable(user);
                this.dashboardMode = user.dashboard;
                this.enterpriseMode = user.enterprise;
                this.enableDynawebs = user.username.indexOf("@mediasignage.com") > -1;
                // this.cd.markForCheck();
            }),
        );

        this.cod(
            this.storeSelector.getLocalStoreUpdates()
                .subscribe((updates) => {
                    this.largeLogo = this.localStoreService.getStorageValConfig("largeLogo");
                    this.experienceLevel = this.localStoreService.getStorageValConfig("experienceLevel");
                    this.showExperienceLevel = this.localStoreService.getStorageValConfig("showExperienceLevel");
                    this.fasterqEnabled = this.localStoreService.getStorageValConfig("fasterqEnabled");
                    this.showHelpEnabled = this.localStoreService.getStorageValConfig("showHelpEnabled");
                    this.cd.markForCheck();
                }),
        );
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                    this.name = this.appStatic.appName;
                }),
        );
        this.cod(
            this.storeSelector.getResellerId(this.localStoreService)
                .subscribe((i_resellerId: number) => {
                    if (i_resellerId === DEFAULT_RESELLER_ID) {
                    } else {
                        this.resellerId = i_resellerId;
                        this.updateBusinessName();
                    }
                }),
        );
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.cod(
                this.accessService.getGroupsCollection("SignStudio Account")
                    .pipe(map((value) => {
                        return !(this.enterpriseMode && value?.$?.visible === "0");
                    }))
                    .subscribe((v) => {
                        this.showAccount = v;
                    }),
            );
            this.navEnterprise$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navEnterprise ? value.$.navEnterprise : "1"));
            this.navUser$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navUser ? value.$.navUser : "1"));
            this.signStudioSettings$ = this.accessService.getGroupsCollection("SignStudio Settings").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
            this.navUser$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navUser ? value.$.navUser : "1"));

            this.signStudioExperienceLevel$ = this.accessService.getGroupsCollection("SignStudio ExperienceLevel").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));  // alon ???

            this.signStudioHelp$ = this.accessService.getGroupsCollection("SignStudio Help").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
            this.signStudioDownloads$ = this.accessService.getGroupsCollection("SignStudio Downloads").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
            this.signStudioProducts$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navProducts ? value.$.navProducts : "1"));
            this.signStudioFasterQ$ = this.accessService.getGroupsCollection("SignStudio FasterQ").pipe(map((value) => value && value.$.visible ? value.$.visible : "1"));
        });
    }

    updateBusinessName() {
        if (this.user?.businessName && this.user?.businessName?.length > 2) {
            this.businessName = this.user.businessName;
            this.cd.markForCheck();
        }
    }

    goToHome() {
        this.appService.goToHomePage(true);
    }

    upgrade() {
        this.appService.openWizardUpgradeDialog();
        this.router.navigateByUrl("/home");
    }

    onRouterClick(): void {
        // /help/signquick
        // this.routerClick.emit();
    }

    openExperienceSelect(): void {
        if (!this.expSelect) return;
        this.expSelect.open();
    }

    onExperienceLevelChange(event: any): void {
        this.localStoreService.setStorageValConfig("experienceLevel", event.value);
    }
}

